import { getFunctions, httpsCallable } from 'firebase/functions'
import { functions } from './firebase' // Import the shared instance

/**
 * Track failed login attempts
 * @param {string} email - The user's email address
 * @returns {Promise<Object>} - Result with success status and lockout info if relevant
 */
export const trackFailedLoginAttempt = async (email) => {
  if (!email) return { success: false, error: 'Email is required' }

  try {
    const trackFailedLogin = httpsCallable(functions, 'trackFailedLogin')
    const result = await trackFailedLogin({ email })
    return result.data
  } catch (error) {
    console.error('Error tracking failed login attempt:', error)
    return { success: false, error: error.message }
  }
}

/**
 * Check if an account is locked
 * @param {string} email - The user's email address
 * @returns {Promise<Object>} - Result with lock status
 */
export const checkAccountLockStatus = async (email) => {
  if (!email) return { locked: false }

  try {
    const checkLockStatus = httpsCallable(functions, 'checkAccountLockStatus')
    const result = await checkLockStatus({ email })
    return result.data
  } catch (error) {
    console.error('Error checking account lock status:', error)
    return { locked: false }
  }
}

/**
 * Reset failed login attempts after successful login
 * @param {string} email - The user's email address
 */
export const resetLoginAttempts = async (email) => {
  if (!email) return

  try {
    const resetAttempts = httpsCallable(functions, 'resetLoginAttempts')
    const result = await resetAttempts({ email })
    return result.data
  } catch (error) {
    console.error('Error resetting login attempts:', error)
    return { success: false, error: error.message }
  }
}
